import 'css-chunk:src/video/video.module.scss';export default {
  "heading-xxl": "video-module__heading-xxl___iIwnE",
  "wrapper": "video-module__wrapper___Tals-",
  "heading-xl": "video-module__heading-xl___3vQh4",
  "heading-lg": "video-module__heading-lg___-4RyJ",
  "heading-md": "video-module__heading-md___wZp-x",
  "heading-sm": "video-module__heading-sm___8ch1e",
  "heading-xs": "video-module__heading-xs___0gJE2",
  "body-one": "video-module__body-one___banb1",
  "body-two": "video-module__body-two___qsa0N",
  "body-three": "video-module__body-three___Pw28X",
  "body-four": "video-module__body-four___FVYI-",
  "overline-one": "video-module__overline-one___3fJLy",
  "overline-two": "video-module__overline-two___j1MfY",
  "overline-three": "video-module__overline-three___qlbHg",
  "strong": "video-module__strong___XrgFY",
  "em": "video-module__em___racxf",
  "figcaption": "video-module__figcaption___ovVJi",
  "no-margin": "video-module__no-margin___elfRY",
  "videoComponentContainer": "video-module__videoComponentContainer___ntuAN",
  "videoWrapper": "video-module__videoWrapper___liwmB",
  "errorPlaceholder": "video-module__errorPlaceholder___zjcH0",
  "cookieConsentButton": "video-module__cookieConsentButton___a5EEM",
  "footer": "video-module__footer___--lQ3",
  "download": "video-module__download___0zQPU",
  "posterImage": "video-module__posterImage___-utls",
  "playButtonBackground": "video-module__playButtonBackground___1DPwk",
  "playButton": "video-module__playButton___ubD3R",
  "facade": "video-module__facade___5EzFQ"
};